export default "__VITE_ASSET__DPIWBY5$__"